import * as DateHelper from "@/Utility/DateHelper";

declare let QRCode: any;
declare var html2canvas: any;

export default class QRCodeHelper {
    public static createQRCodeOnElement(element: JQuery<HTMLElement>, token: string) {
        if (!element || element.length === 0)
            console.error('Please provide an element on which a qr-code shold be created!')
        
        QRCodeHelper.cleanUpArea(element);

        new QRCode(element[0], {
            text: token,
            width: 256,
            height: 256,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
        });

        let title = element.attr('title');
        title = title.replace(/[&?]?digits=\d*/i, ''); // CF-93041
        element.attr('title', title);
    }
    
    public static cleanUpArea(element: JQuery<HTMLElement>) {
        if (!element || element.length === 0)
            console.error('Please provide an element which should gets cleaned!')
        
        element.empty();
    }

    public static downloadQRCode(userName: string): void {
        const date = new Date();
        const dateFormatted = DateHelper.toDotNetDateTimeString(date);
        const divQR = document.getElementById('QR2pdf');

        html2canvas(divQR, { scale: 3 }).then((canvas: HTMLCanvasElement) => {
            const newCanvas = this.createCanvasForImage(canvas);

            // Export als PNG
            newCanvas.toBlob((blob) => {
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${userName}_D${dateFormatted}_QRCode.png`;
                link.click();
                URL.revokeObjectURL(url);
            });
        });
    }

    private static createCanvasForImage(canvas: HTMLCanvasElement) {
        const padding = 20;
       
        const newCanvas = document.createElement('canvas');
        newCanvas.width = canvas.width + padding * 2;
        newCanvas.height = canvas.height + padding * 2;
        
        const ctx = newCanvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);
        ctx.drawImage(canvas, padding, padding);
        
        return newCanvas;
    }
}
